import { observer } from 'mobx-react';

import PropTypes from 'prop-types';

import BaseCustomTextField from 'components/custom_fields/BaseCustomTextField';

const isZip = zip => {
  const re = /^\d{5}(?:[-\s]\d{4})?$/;
  return re.test(String(zip));
};

const ZipField = ({ value, onChange, onKeyDown, className, label, name, id, disabled }) => (
  <BaseCustomTextField
    value={value}
    onChange={onChange}
    onKeyDown={onKeyDown}
    checkIsValid={isZip}
    helperText="Invalid format: XXXXX"
    label={label}
    name={name}
    id={id}
    className={className}
    disabled={disabled}
  />
);

ZipField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

ZipField.defaultProps = {
  label: 'Zip Code',
  name: 'zipCode',
  id: 'zipCode',
  value: '',
  onChange: () => {},
  onKeyDown: () => {},
  className: '',
  disabled: false,
};
export default observer(ZipField);
